import React from 'react'

export const NoResults = (props) => {
  const headings = props.heading?.content?.[0]?.content || []
  const bodies = props.content?.content?.[0]?.content || []
  return (
    <div className='NoResults'>
      {headings.map(({ value }: { value: string }, idx: number) => (
        <div className='NoResults-heading' key={idx}>
          {value}
        </div>
      ))}
      {bodies.length > 0 && (
        <div className='NoResults-body'>
          {bodies.map(({ value }: { value: string }, idx: number) => (
            <div className='NoResults-line' key={idx}>
              {value}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
